<template>
  <div
    class="sidemenu-wrapper"
    style="
  overflow: auto;"
  >
    <div
      class="sidemenu-open-button"
      @click="openSideMenu()"
      :class="{ show: showSideMenu !== true }"
    >
      <div class="sidemenu-open-button-inner">
        <div></div>
      </div>
    </div>
    <div
      class="sidemenu"
      :class="{ show: showSideMenu === true }"
      style="
  overflow: auto"
    >
      <div class="sidemenu-close-button" @click="closeSideMenu(true)"></div>

      <div class="logo"></div>

      <div class="menu">
        <!-- <router-link
          @click.native="closeSideMenu(true)"
          to="/settings"
          :class="{ active: activePage === 'Settings' }"
          v-if="session.type <= 1"
          >Настройка</router-link
        >
        <router-link
          @click.native="closeSideMenu(true)"
          to="/transactions"
          :class="{ active: activePage === 'Transactions' }"
          >Транзакции</router-link
        >
        <router-link
          @click.native="closeSideMenu(true)"
          to="/outputs"
          :class="{ active: activePage === 'Outputs' }"
          >Вывод баланса</router-link
        > -->
        <router-link
          @click.native="closeSideMenu(true)"
          to="/ledger"
          :class="{ active: activePage === 'Ledger' }"
          v-if="session.type <= 1"
          >Учет</router-link
        >
        <router-link
          @click.native="closeSideMenu(true)"
          to="/deposits"
          :class="{ active: activePage === 'Deposits' }"
          >Депозиты</router-link
        >
        <router-link
          @click.native="closeSideMenu(true)"
          to="/sites"
          :class="{ active: activePage === 'Sites' }"
          v-if="session.type <= 1"
          >Сайты</router-link
        >
        <a
          href="#"
          @click="toggleAccordion(3)"
          class="nav-link"
          :class="{ active: activePage === '' }"
          v-if="session.type <= 1"
          >Справочники</a
        >
        <div class="dictionaries" v-show="activeAccordion === 3">
          <router-link
            @click.native="closeSideMenu(false)"
            to="/sourcetypes"
            :class="{ active: activePage === 'SourceTypes' }"
            >Типы</router-link
          >
          <router-link
            @click.native="closeSideMenu(false)"
            to="/projects"
            :class="{ active: activePage === 'Projects' }"
            >Проекты</router-link
          >
          <router-link
            @click.native="closeSideMenu(false)"
            to="/valutes"
            :class="{ active: activePage === 'Valutes' }"
            v-if="session.type <= 1"
            >Валюты</router-link
          >
          <!-- <router-link
            @click.native="closeSideMenu(false)"
            to="/cross-rate"
            :class="{ active: activePage === 'CrossRate' }"
            v-if="session.type <= 1"
            >Кросс Курс</router-link
          >
          <router-link
            @click.native="closeSideMenu(false)"
            to="/trade-pairs"
            :class="{ active: activePage === 'TradePairs' }"
            v-if="session.type <= 1"
            >Валютные Пары</router-link
          > -->
          <!-- 			<router-link @click.native="closeSideMenu(false)" to="/wallet-generation" :class="{ 'active': activePage === 'WalletGeneration' }" v-if="session.type === 1">Генерация кошельков</router-link> -->
          <!-- <router-link
            @click.native="closeSideMenu(false)"
            to="/reserve"
            :class="{ active: activePage === 'Reserve' }"
            v-if="session.type <= 1"
            >Резерв</router-link
          >
          <router-link
            @click.native="closeSideMenu(false)"
            to="/parse-valutes"
            :class="{ active: activePage === 'ParseValutes' }"
            v-if="session.type <= 1"
            >Парсинг Валют</router-link
          >
          <router-link
            @click.native="closeSideMenu(false)"
            to="/wallets"
            :class="{ active: activePage === 'Wallets' }"
            >Кошельки</router-link
          > -->
          <router-link
            @click.native="closeSideMenu(false)"
            to="/users"
            :class="{ active: activePage === 'Users' }"
            >Пользователи</router-link
          >
          <!-- <router-link
            @click.native="closeSideMenu(false)"
            to="/reviews"
            :class="{ active: activePage === 'Reviews' }"
            >Отзывы</router-link
          >
          <router-link
            @click.native="closeSideMenu(false)"
            to="/apiusers"
            :class="{ active: activePage === 'ApiUsers' }"
            v-if="session.type <= 1"
            >Пользователи API</router-link
          >
          <router-link
            @click.native="closeSideMenu(false)"
            to="/cards"
            :class="{ active: activePage === 'RTApiCards' }"
            v-if="session.type <= 1"
            >Карты RTAPI</router-link
          >
          <router-link
            @click.native="closeSideMenu(false)"
            to="/valute-cities"
            :class="{ active: activePage === 'ValuteCities' }"
            v-if="session.type <= 1"
            >Города</router-link
          > -->
        </div>
        <!-- <router-link @click.native="closeSideMenu(false)" to="/support" :class="{ 'active': activePage === 'Support' }">Поддержка</router-link> -->
        <a href="#" class="logout-link" @click.prevent="logout">Выйти</a>
      </div>
    </div>
  </div>
</template>

<style scoped>
#app > .sidemenu-wrapper {
  position: fixed;
  z-index: 9997;
  height: 100%;
  overflow: auto;
}

#app > .sidemenu-wrapper > .sidemenu {
  display: none;
  position: fixed;
  color: rgb(160, 162, 166);
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  transition: opacity linear 0.3s;
  -webkit-transition: opacity linear 0.3s;
  height: 100%;
}

#app > .sidemenu-wrapper > .sidemenu.show {
  display: block;
}

#app > .sidemenu-wrapper > .sidemenu > .sidemenu-close-button {
  position: fixed;
  text-align: right;
  top: 5px;
  right: 6px;
  width: 50px;
  height: 50px;
  cursor: pointer;
}

.sidemenu-open-button {
  position: fixed;
  top: 5px;
  right: 13px;
  cursor: pointer;
  width: 28px;
  height: 40px;
  padding: 5px 5px;
  vertical-align: top;
  display: none;
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}

.sidemenu-open-button.show {
  display: block;
}

.sidemenu-open-button-inner {
  position: relative;
  display: block;
  width: 100%;
  height: 2px;
  margin-top: 18px;
  background: rgb(239 214 169);
  cursor: pointer;
}

.sidemenu-open-button-inner div {
  width: 100%;
  height: 100%;
}

.sidemenu-open-button-inner:before,
.sidemenu-open-button-inner:after {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  background: rgb(239 214 169);
}

.sidemenu-open-button-inner:before {
  top: -8px;
}

.dictionaries {
  background: rgb(39 28 23 / 30%);
  margin: 5px;
  border: 1px solid rgb(239 214 169 / 28%);
}

.dictionaries a {
  line-height: 0.8;
  font-size: 13px;
  text-decoration: none;
  text-align: center;
  color: rgb(206 172 110);
  display: block;
  padding: 7px;
}

#app > .sidemenu-wrapper > .sidemenu > .menu > a.active,
#app > .sidemenu-wrapper > .sidemenu > .menu > a:hover,
#app > .sidemenu-wrapper > .sidemenu > .menu > .dictionaries a.active,
#app > .sidemenu-wrapper > .sidemenu > .menu > .dictionaries a:hover {
  background-color: rgb(155 123 89 / 85%);
  color: #ffffff;
}

.sidemenu-open-button-inner:after {
  top: 8px;
}

#app > .sidemenu-wrapper > .sidemenu > .sidemenu-close-button:before,
#app > .sidemenu-wrapper > .sidemenu > .sidemenu-close-button:after {
  content: "";
  position: absolute;
  top: 23px;
  left: 12px;
  width: 26px;
  height: 2px;
  background: rgb(239 214 169);
}

#app > .sidemenu-wrapper > .sidemenu > .sidemenu-close-button:before {
  webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}

#app > .sidemenu-wrapper > .sidemenu > .sidemenu-close-button:after {
  webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}

#app > .sidemenu-wrapper > .sidemenu > .logo {
  width: 100%;
  text-align: left;
  height: 60px;
}

#app > .sidemenu-wrapper > .sidemenu > .logo > .text {
  padding: 20px;
  text-decoration: underline;
}

#app > .sidemenu-wrapper > .sidemenu > .menu > .logout-link {
  margin-top: 16px;
  border-top: 1px solid rgb(239 214 169 / 20%);
  color: #e57373;
}

#app > .sidemenu-wrapper > .sidemenu > .menu > .logout-link:hover {
  background-color: rgb(229 115 115 / 20%);
  color: #ef9a9a;
}
</style>

<script>
import { mapState, mapMutations } from "vuex";
//
export default {
  name: "SideMenu",
  data: () => ({
    activeAccordion: null,
    showSideMenu: false
  }),
  computed: {
    ...mapState(["activePage"]),
    ...mapState("auth", ["session"])
  },
  methods: {
    ...mapMutations("auth", ["setSession"]),
    logout() {
      localStorage.removeItem("Auth");
      this.setSession(null);
      this.$router.push("/login");
    },
    toggleAccordion(index) {
      if (this.activeAccordion === index) {
        this.activeAccordion = null;
      } else {
        this.activeAccordion = index;
      }
    },
    openSideMenu() {
      this.showSideMenu = true;
    },
    closeSideMenu(closeAccordion) {
      if (closeAccordion) {
        this.activeAccordion = null;
      }
      this.showSideMenu = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ui/SideMenu.vue